module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "select-goods-box",
    attrs: {
      "title": "选择商品",
      "visible": _vm.goodsVisible,
      "width": "732px",
      "append-to-body": ""
    },
    on: {
      "close": _vm.closeDialog
    }
  }, [(!_vm.filter) ? _c('StoreFilter', {
    staticClass: "store",
    attrs: {
      "data": _vm.store
    },
    on: {
      "change": _vm.handleStoreChange
    }
  }) : _vm._e(), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-position": "left",
      "label-width": "70px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商品名： "
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "请输入商品名称"
    },
    on: {
      "clear": _vm.searchByKey
    },
    model: {
      value: (_vm.params.keywords),
      callback: function($$v) {
        _vm.$set(_vm.params, "keywords", $$v)
      },
      expression: "params.keywords"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-search",
      "type": "danger"
    },
    on: {
      "click": _vm.searchByKey
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "0"
    }
  }, [_c('el-transfer', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "titles": ['商品列表', '已选中'],
      "button-texts": ['移除选择', '添加选择'],
      "data": _vm.goodsList
    },
    on: {
      "change": _vm.goodsSelector
    },
    model: {
      value: (_vm.selectedGoods),
      callback: function($$v) {
        _vm.selectedGoods = $$v
      },
      expression: "selectedGoods"
    }
  }, [_c('div', {
    staticClass: "transfer-footer",
    attrs: {
      "slot": "left-footer"
    },
    slot: "left-footer"
  }, [(_vm.total_count > _vm.params.pageSize) ? _c('el-pagination', {
    attrs: {
      "small": "",
      "layout": "prev, pager, next",
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.pageChange
    }
  }) : _vm._e()], 1)])], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.goodsComfirm
    }
  }, [_vm._v("确 定")])], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e371fe08", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e371fe08"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/goods_picker/index.vue
// module id = 2955
// module chunks = 0